// src/helpers/api.js
import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE ||
  (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000");

/* =========================
   CONFIG GLOBAL (compatibilidad)
   ========================= */
axios.defaults.baseURL = String(API_BASE).replace(/\/+$/, "");
axios.defaults.withCredentials = false;

axios.interceptors.request.use((config) => {
  const tk =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("jwt") ||
    "";

  config.headers = config.headers || {};

  if (tk) {
    config.headers.token = tk; // tu back lo usa
    config.headers.Authorization = `Bearer ${tk}`; // no molesta
  } else {
    delete config.headers.token;
    delete config.headers.Authorization;
  }

  if (!config.headers["Content-Type"] && String(config.method).toLowerCase() !== "get") {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

axios.interceptors.response.use(
  (r) => r,
  (err) => {
    console.error("❌ API ERROR", {
      method: err?.config?.method,
      url: err?.config?.url,
      baseURL: err?.config?.baseURL,
      status: err?.response?.status,
      data: err?.response?.data,
      message: err?.message,
    });
    return Promise.reject(err);
  }
);

/* =========================
   Instancia (para helpers nuevos)
   ========================= */
const api = axios.create({
  baseURL: axios.defaults.baseURL,
  withCredentials: false,
  timeout: 30000,
});

// Reusa el interceptor global
api.interceptors.request.use((config) => axios.interceptors.request.handlers[0].fulfilled(config));

async function apiGet(path, config = {}) {
  const res = await api.get(path, config);
  return res.data;
}
async function apiPost(path, body = {}, config = {}) {
  const res = await api.post(path, body, config);
  return res.data;
}
async function apiPut(path, body = {}, config = {}) {
  const res = await api.put(path, body, config);
  return res.data;
}
async function apiDelete(path, config = {}) {
  const res = await api.delete(path, config);
  return res.data;
}

export const API_URL = axios.defaults.baseURL;

export default api;
export { axios, apiGet, apiPost, apiPut, apiDelete };